import {
  SIGNUP,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  SEND_USER_INFO,
  SEND_USER_INFO_SUCCESS,
  SEND_USER_INFO_FAILURE,
  SEND_PART_USER_INFO_SUCCESS,
  SELECT_LANGUAGE,
  DELETE_SELECTED_LANGUAGE,
  DELETE_SELECTED_LANGUAGE_SUCCESS,
  SELECT_SUBCATEGORY,
  DELETE_SELECTED_SUBCATEGORY,
  RECEIVE_USER_INFO,
  RECEIVE_USER_INFO_SUCCESS,
  RECEIVE_USER_INFO_FAILURE,
  GET_SENDED_INFO,
  REQUEST_CATEGORIES,
  RECEIVE_CATEGORIES,
  NOT_RECEIVE_CATEGORIES,
  ADD_CURRENCIES_FOR_USER_STATE,
  ADD_LANGUAGES_FOR_USER_STATE,
} from '../../constants/ActionTypes';

export default function userOnboardingReducer(state, action) {
  switch (action.type) {
    case SIGNUP:
      return {
        ...state,
        isSending: true,
      };

    case SIGNUP_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isSending: false,
        isFetching: false,
        isPartner: true,
        errors: [],
      };

    case SIGNUP_FAILURE:
      return {
        ...state,
        isSending: false,
        isFetching: false,
        error: action.error,
        errors: action.errors,
      };

    case SEND_USER_INFO:
      return {
        ...state,
        isSending: true,
      };

    case SEND_USER_INFO_SUCCESS:
      return {
        ...state,
        receivedUserInfo: { ...action.data },
        isSending: false,
        errors: [],
      };

    case SEND_USER_INFO_FAILURE:
      return {
        ...state,
        isSending: false,
        error: action.error,
        errors: action.errors,
      };

    case SEND_PART_USER_INFO_SUCCESS:
      return {
        ...state,
        receivedUserInfo: { ...action.payload },
        isSending: false,
        deletingAttribute: '',
        errors: [],
      };

    case SELECT_LANGUAGE:
      return {
        ...state,
        isSending: true,
      };

    case DELETE_SELECTED_LANGUAGE:
      return {
        ...state,
        isSending: true,
        deletingAttribute: 'language',
      };

    case DELETE_SELECTED_LANGUAGE_SUCCESS:
      return {
        ...state,
        languagesSelected: state.languagesSelected.filter(
          (el) => el.id !== action.id
        ),
        isSending: false,
        deletingAttribute: '',
      };

    case SELECT_SUBCATEGORY:
      return {
        ...state,
        isSending: true,
      };

    case DELETE_SELECTED_SUBCATEGORY:
      return {
        ...state,
        isSending: true,
        deletingAttribute: 'subcategory',
      };

    case RECEIVE_USER_INFO:
      return {
        ...state,
        isFetching: true,
      };

    case RECEIVE_USER_INFO_SUCCESS:
      return {
        ...state,
        isFetching: false,
        receivedUserInfo: action.payload,
        errors: [],
      };

    case RECEIVE_USER_INFO_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        errors: action.errors,
      };

    case GET_SENDED_INFO:
      return {
        ...state,
        subcategoriesSelected: state.categories
          .flatMap((i) => i.subcategories)
          .filter((n) => state.receivedUserInfo.subcategories.includes(n.id)),
        languagesSelected: state.languages.filter((i) =>
          state.receivedUserInfo.languages.includes(i.id)
        ),
        currencyId:
          state.currencies.find(
            (i) => i.id === state.receivedUserInfo.currencyId
          ) === undefined
            ? null
            : state.currencies.find(
                (i) => i.id === state.receivedUserInfo.currencyId
              ),
      };

    case REQUEST_CATEGORIES:
      return {
        ...state,
        isFetching: true,
      };

    case RECEIVE_CATEGORIES:
      return {
        ...state,
        isFetching: false,
        categories: action.data,
      };

    case NOT_RECEIVE_CATEGORIES:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        errors: action.errors,
      };

    case ADD_CURRENCIES_FOR_USER_STATE:
      return {
        ...state,
        currencies: action.data,
      };

    case ADD_LANGUAGES_FOR_USER_STATE:
      return {
        ...state,
        languages: action.data,
      };

    default:
      return state;
  }
}
